<script setup lang="ts"></script>

<template>
  <q-layout view="lHh lpR lFf">
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>
